const legitimationOnboardingDocumentEnum = Object.assign({
  ID_CARD: { name: 'Id card', value: 'Id' },
  PASSPORT: { name: 'Passport', value: 'TravelPassport' },
});

Object.freeze(legitimationOnboardingDocumentEnum);

function getEnumAsArray() {
  return Object.keys(legitimationOnboardingDocumentEnum)
    .map(key => ({
      name: legitimationOnboardingDocumentEnum[key].name,
      value: legitimationOnboardingDocumentEnum[key].value,
    }));
}

export const legitimationOnboardingDocumentArray = getEnumAsArray();

export default legitimationOnboardingDocumentEnum;



// WEBPACK FOOTER //
// ./src/enum/user/LegitimationOnboardingDocument.js